// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2qQ07","bigColWidth":"Table_bigColWidth__2fO35","biggerColWidth":"Table_biggerColWidth__2oltJ","row":"Table_row__1vqm8","col":"Table_col__a9Bol"};